<template>
  <div
    class="game-item"
    :class="{
      'premium-only': !parentAccountData.premium_access && game.isPremium,
      'notPremiumAccess': !hasPremiumAccess,
    }"
  >
    <div class="game-item-actions">
      <button
        v-if="!hasPremiumAccess"
        class="game-item-actions-item add-to-playlist"
        @click.stop
      >
        <v-icon>lock</v-icon>
      </button>
      <router-link
        v-if="!game.isPremium || (game.isPremium && parentAccountData.premium_access)"
        class="game-item-actions-item"
        :to="{ name: 'game', params: { id: game.id } }"
      >
        <img :src="require('@/assets/games/play-icon.png')" alt="">
      </router-link>
    </div>
    <premium-game-icon v-if="game.isPremium" />
    <grade-icon :game="game" class="game-item-info-grade" />
    <category-icon
      :category="game.category"
      class="game-item-info-category"
    />
    <mastered-game-icon
      v-if="masteredGames.includes(game.id)"
    />
    <div class="game-item-preview">
      <img
        :src="`https://s3.amazonaws.com/images.growmindgrow/previews/${game.preview}`"
        alt
      />
    </div>
    <div class="game-item-info">
      <div class="game-item-info-description ">
        <p>{{ game.name }}</p>
        <span>{{ game.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CategoryIcon from '@/components/icons/CategoryIcon';
import GradeIcon from '@/components/icons/GradeIcon';
import PremiumGameIcon from '@/components/icons/PremiumGameIcon';
import MasteredGameIcon from '@/components/icons/MasteredGameIcon';

export default {
  name: 'GameItem',
  components: {
    CategoryIcon, GradeIcon, PremiumGameIcon, MasteredGameIcon,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    masteredGames: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters({
      parentAccount: 'parent/parentAccount',
    }),
    parentAccountData() {
      return this.parentAccount || {};
    },
    hasPremiumAccess() {
      return !this.game.isPremium || (this.game.isPremium && this.parentAccountData.premium_access);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

.game-item {
  max-width: 287px;
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 3px 1px -2px rgba(51,51,51,.2), 0 2px 2px 0 rgba(51,51,51,.14),
   0 1px 5px 0 rgba(51,51,51,.12);
  transition: 0.25s;
  border-color: #ACFAFF;
  border-style: solid;
  border-width: 0;

  &.notPremiumAccess {
    cursor: auto;

    &:hover {
      transform: scale(1) !important;

      .game-item-actions-item {
        cursor: default;
      }
    }

    .game-item-actions {
      opacity: 1;
      z-index: 1;
    }
  }

  &:hover {
    .game-item-actions {
      opacity: 1;
      z-index: 1;
    }
  }

  .premium-game-icon {
    position: absolute;
    left: -34px;
    top: 5px;
    z-index: 1;

    @include for-size(small-tablets-only-or-landscape) {
      top: 10px;
      left: 10px;
    }
  }

  &-preview {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 16px 16px 0 0;
    height: 158px;
    @include for-size(small-tablets-only-or-landscape) {
      border-radius: 4px 4px 0 0;
      height: 150px;
    }
    img {
      height: 190px;

      @media (max-width: 1920px) {
        height: 164px;
      }

      @include for-size(small-tablets-only-or-landscape) {
        height: 100%;
      }

      @media (max-width: 350px) {
        min-width: 400px;
      }
    }
  }

  &-actions {
    opacity: 0;
    transition: 0.5s;
    transition-delay: 0.25s;
    width: 100%;
    height: 158px;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.33);
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    &-item {
      width: 80px;
      height: 80px;
      background: rgba(255,255,255,0.75);
      border-radius: 50%;
      border: 2px solid #929292;
      img {
        width: 100%;
      }

      &.add-to-playlist {
        i {
          color: #929292;
        }
      }
    }

    @include for-size(small-tablets-only-or-landscape) {
      display: none;
    }
  }

  &-info {
    width: 100%;
    position: relative;
    z-index: 1;

    &-grade {
      position: absolute;
      right: -16px;
      top: 16px;
      z-index: 1;

      @include for-size(small-tablets-only-or-landscape) {
        right: 10px;
        top: 10px;
        width: 40px !important;
        height: 40px !important;
        font-size: 12px;
      }
    }

    &-category {
      right: -16px;
      top: 76px;
      position: absolute !important;
      z-index: 1;

      @include for-size(small-tablets-only-or-landscape) {
        right: 60px;
        top: 10px;
        width: 40px !important;
        height: 40px !important;
      }

      .categoty-icon {
        @include for-size(small-tablets-only-or-landscape) {
          width: 40px !important;
          height: 40px !important;
        }
      }
    }

    &-header {
      background: rgba(0, 0, 0, 0.33);
      width: 100%;
      color: #fff;
      font-size: 18px;
      text-align: center;
      padding: 5px 10px;
      position: absolute;
      bottom: 0;
      height: 50px;

      span {
        line-height: 40px;
      }

      img {
        height: 40px;
        width: 40px;
        position: absolute;
        right: 10px;
        display: block;
        padding: 5px;
        border-radius: 50%;
        top: 5px;
      }

      a {
        display: none;
        @include for-size(tablet-only) {
          display: block;
        }
      }
    }

    &-description {
      padding: 6px 16px 14px;
      background-color: #fff;
      border-radius: 0 0 16px 16px;
      color: #000;
      line-height: 18px;

      @include for-size(small-tablets-only-or-landscape) {
        padding: 2px 5px;
      }

      p {
        font-size: 16px;
        margin-bottom: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: 500;

        @include for-size(small-tablets-only-or-landscape) {
          margin: 0;
          padding: 3px 0;
        }
      }

      span {
        @include for-size(small-tablets-only-or-landscape) {
          display: none !important;
        }
      }
    }
  }
}
</style>
